import React, { Component } from "react";
import { connect } from "react-redux";
import { setForm } from "../../../store/actions/form";
import { googleTracking } from '../../../util';
import { Scheduler } from 'fs-scheduler';

class ScheduleInstallation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation
    };

    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.changeSchedule = this.changeSchedule.bind(this);
    this.timesDontWork = this.timesDontWork.bind(this);
    this.contactToSchedule = this.contactToSchedule.bind(this);
  }

  componentDidMount() {
    googleTracking({ 'event': 'virtualPageview', 'pageview': '/not-prewired/step4/schedule-installation' });
    this.setState({
      visible: true,
    });
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: false
    });
    setTimeout(() => {
      changeStep(2, "fade right");
    }, 400);
  }

  contactToSchedule() {
    const { changeStep, setForm } = this.props;

    this.setState({
      animation: "fade right",
      visible: !this.state.visible
    });

    setForm({ timeslot: null, timeslotObj: {}, otherTimeSlot: true });

    setTimeout(() => {
      changeStep(3, "fade left");
    }, 400);
  }

  transitionNext() {
    const { changeStep, setForm } = this.props;

    setForm({ otherTimeSlot: false });

    setTimeout(() => {
      changeStep(3, "fade left");
    }, 400);
  }

  changeSchedule(timeslot) {
    this.props.setForm({ timeslot: timeslot.id, timeslotObj: timeslot });
  }

  timesDontWork() {
    const { setForm } = this.props;
    setForm({ otherTimeSlot: true });
  }

  render() {
    const { timeslots, timeslotId } = this.props;
    const { visible, animation } = this.state;
    return (
      <div>
        <div className="back--icon" onClick={this.transitionBack} />
        <Scheduler
          visible={visible}
          animation={animation}
          timeslots={timeslots}
          selectedTimeslotId={timeslotId}
          onShowMoreClick={this.timesDontWork}
          onTimeslotChange={this.changeSchedule}
          onNextButtonClick={this.transitionNext}
          onContactButtonClick={this.contactToSchedule}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    timeslots: state.timeslots,
    timeslotId: state.form.timeslot
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setForm: data => dispatch(setForm(data))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleInstallation);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-available/ScheduleInstallation.js